import { createContext, useContext, useState, useEffect } from 'react'
import AuthService from '../services/authService'
import helperService from '../services/helperService'

const authContext = createContext()

export default function useAuth() {
	return useContext(authContext)
}

export function AuthProvider(props) {
	const [user, setUser] = useState(null)
	const [error, setError] = useState('')

	const checkForUser = async(alert, email) => {
		const status = await helperService.awaitFetch('/api/auth', {
			action: 'magic',
			token: true,
			email
		})
		if (status?.success === false) {
			alert('User with email ' + email + ' is not registered', 'error')
		}	
	}

	const loginWithGoogle = async alert => {
		const { error, user } = await AuthService.loginWithGoogle().catch(error => {
			alert(`Login Error: ${JSON.parse(JSON.stringify(error))?.code}`, 'error')
		}) || {}
		user ? await checkForUser(alert, user?.email) : ''
		setUser(user ?? null)
		setError(error ?? '')
	}
	const loginWithMicrosoft = async alert => {
		const { error, user } = await AuthService.loginWithMicrosoft().catch(error => {
			alert(`Login Error: ${JSON.parse(JSON.stringify(error))?.code}`, 'error')
		}) || {}
		user ? await checkForUser(alert, user?.email) : ''
		setUser(user ?? null)
		setError(error ?? '')
	}
	const loginWithLink = async (email, token, alert) => {
		const { error, user } = await AuthService.loginWithLink(email, token, alert)
		setUser(user ?? null)
		setError(error ?? '')
	}

	const logout = async () => {
		await AuthService.logout()
		setUser(null)
	}
	const value = { user, error, loginWithGoogle, loginWithMicrosoft,  loginWithLink, logout, setUser }

	return <authContext.Provider value={value} {...props} />
}
